/**
 * Global handler for back buttons
 * Maneja todos los elementos con fr-dashboard-element="back-button"
 * para ejecutar history.back() al hacer click
 */
document.addEventListener('DOMContentLoaded', function () {
    console.log('Initializing global back button handlers');

    // Función para configurar un botón de back
    function setupBackButton(button) {
        if (button.hasAttribute('data-back-initialized')) {
            return; // Ya fue inicializado
        }

        button.setAttribute('data-back-initialized', 'true');
        button.addEventListener('click', function (event) {
            event.preventDefault();
            console.log('Back button clicked, executing history.back()');
            window.history.back();
        });

        console.log('Back button configured:', button);
    }

    // Configurar botones existentes
    const backButtons = document.querySelectorAll('[fr-dashboard-element="back-button"]');
    backButtons.forEach(setupBackButton);

    // Observer para botones que se agreguen dinámicamente
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) { // Element node
                    // Verificar si el nodo agregado es un botón de back
                    if (node.getAttribute && node.getAttribute('fr-dashboard-element') === 'back-button') {
                        setupBackButton(node);
                    }

                    // Verificar si contiene botones de back
                    const childBackButtons = node.querySelectorAll ? node.querySelectorAll('[fr-dashboard-element="back-button"]') : [];
                    childBackButtons.forEach(setupBackButton);
                }
            });
        });
    });

    // Observar cambios en el DOM
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    console.log(`Initialized ${backButtons.length} back buttons and set up dynamic observer`);
});
